import './zoom-controls.scss';
import { ReactComponent as ZoomIn } from '../../assets/zoom-in.svg';
import { ReactComponent as ZoomOut } from '../../assets/zoom-out.svg';
import { useNavigation } from '../../contexts/navigation.context';

interface ZoomControlsProps {
	// onZoomIn: React.MouseEventHandler<HTMLDivElement>;
	// onZoomOut: React.MouseEventHandler<HTMLDivElement>;
}

const ZoomControls: React.FunctionComponent<ZoomControlsProps> = ({}) => {
	const { map } = useNavigation();

	return (
		<div className="zoom-controls-wrapper">
			<div className="single-control underline" onClick={() => map?.current?.zoomIn()}>
				<ZoomIn />
			</div>
			<div className="single-control" onClick={() => map?.current?.zoomOut()}>
				<ZoomOut />
			</div>
		</div>
	);
};

export default ZoomControls;
